import React, { useRef } from "react";
import FormikInput from "../../../../Components/Formik/FormikInput";
import { useFormikContext } from "formik";
import { COMPANY_DOMAIN } from "../../../../utilities/constants";
import { useLanguage } from "../../../../Components/LangTranslation/LanguageContext";
import { useSession } from "../../../../authentications/SessionContext";
import { checkApi } from "../../../../DataApi/onboarding/checkApi";

function VerifyEmailStep({ setIsVerified, handleCloseLoader }) {
  const { setFieldValue, errors, touched, setFieldTouched } =
    useFormikContext();
  const { language, translations } = useLanguage();
  const t = translations[language];
  const domainRef = useRef(null);
  const onChange = () => {
    setIsVerified(false);
  };

  const onChangeBusinessName = async (e) => {
    const { name, value } = e.target;
    setFieldValue(name, value);
    if (domainRef.current) {
      const domainValueFiltered = value
        .replace(/[^a-zA-Z0-9]/g, "")
        .toLowerCase()
        .slice(0, 10);
      domainRef.current.value = domainValueFiltered;
      setFieldValue("domain_name", domainValueFiltered);
      setFieldValue("domain", `${domainValueFiltered}.${COMPANY_DOMAIN}`);
      // Check if domain exists
      try {
        const [domainCheckResponse = {}] = await Promise.all([
          checkApi({
            params: { domain: domainValueFiltered },
            endpoint: "/onboarding/domain_check",
          }),
        ]);
        if (domainCheckResponse?.result?.result?.exists === true) {
          setFieldValue("domain_exists", true);
          setFieldTouched("domain_name", true);
        } else {
          setFieldValue("domain_exists", false);
        }
      } catch (error) {
        console.error("Error checking domain availability:", error);
      } finally {
        handleCloseLoader();
      }
    }
  };
  return (
    <>
      <div className="my-3 col-12">
        <FormikInput
          onChange={onChange}
          handleOnBlur={async (e) => {
            const { value, name } = e.target;
            setFieldTouched(name, true);
            try {
              const response = await Promise.all([
                checkApi({
                  params: { user: value },
                  endpoint: "/onboarding/user_check",
                }),
              ]);
              const [userCheckResponse = {}] = response;
              if (userCheckResponse?.result?.result?.exists === true) {
                setFieldValue("email_exists", true);
              } else {
                setFieldValue("email_exists", false);
              }
            } catch (error) {
              console.error("Error checking user esixt:", error);
            } finally {
              handleCloseLoader();
            }
          }}
          name="email"
          placeholder={t["Email Address"]}
        />
      </div>
      <div className="my-3 col-12">
        <FormikInput
          name="business_name"
          onChange={onChangeBusinessName}
          handleOnBlur={async (e) => {
            const { value, name } = e.target;
            setFieldTouched(name, true);
            try {
              const response = await Promise.all([
                checkApi({
                  params: { company_name: value },
                  endpoint: "/onboarding/check_company",
                }),
              ]);
              const [userCheckResponse = {}] = response;
              if (userCheckResponse?.result?.result?.exists === true) {
                setFieldValue("business_exists", true);
              } else {
                setFieldValue("business_exists", false);
              }
            } catch (error) {
              console.error("Error checking business esixt:", error);
            } finally {
              handleCloseLoader();
            }
          }}
          placeholder={t["Business Name"]}
        />
      </div>
      <div className="mt-3 col-12 d-flex domain-input-wrapper ">
        <input
          name="domain_name"
          ref={domainRef}
          maxLength="10"
          onChange={(e) => {
            const { name, value } = e.target;
            setFieldValue(name, value);
            setFieldValue("domain", `${value}.${COMPANY_DOMAIN}`);
          }}
          onBlur={async (e) => {
            const { value, name } = e.target;
            setFieldTouched(name, true);

            try {
              const [domainCheckResponse = {}] = await Promise.all([
                checkApi({
                  params: { domain: value },
                  endpoint: "/onboarding/domain_check",
                }),
              ]);
              if (domainCheckResponse?.result?.result?.exists === true) {
                setFieldValue("domain_exists", true);
              } else {
                setFieldValue("domain_exists", false);
              }
            } catch (error) {
              console.error("Error checking domain exists:", error);
            } finally {
              handleCloseLoader();
            }
          }}
          type="text"
          className="domain-input form-control"
          placeholder={t["Domain Name"]}
          aria-label="Domain"
          aria-describedby="basic-addon2"
        />
        <span
          style={{ height: 56 }}
          className="input-group-text responsive-ellipsis"
          id="basic-addon2"
        >
          .{COMPANY_DOMAIN}
        </span>
      </div>
      {touched?.domain_name && (
        <span style={{ fontSize: 14, color: "red" }}>{errors.domain_name}</span>
      )}

      <div className="my-3 col-md-6 col-12">
        <FormikInput
          name="first_name"
          onChange={onChange}
          placeholder={t["First Name"]}
        />
      </div>
      <div className="my-3 col-md-6 col-12">
        <FormikInput
          name="last_name"
          onChange={onChange}
          placeholder={t["Last Name"]}
        />
      </div>
    </>
  );
}

export default VerifyEmailStep;
